import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('campaigns')

export const FETCH_CAMPAIGN = makeConstant('FETCH_CAMPAIGN')
export const FETCH_CAMPAIGN_PENDING = makeConstant('FETCH_CAMPAIGN_PENDING')
export const FETCH_CAMPAIGN_CANCELLED = makeConstant('FETCH_CAMPAIGN_CANCELLED')
export const FETCH_CAMPAIGN_FAILED = makeConstant('FETCH_CAMPAIGN_FAILED')

export const UPDATE_CAMPAIGN = makeConstant('UPDATE_CAMPAIGN')
export const UPDATE_CAMPAIGN_PENDING = makeConstant('UPDATE_CAMPAIGN_PENDING')
export const UPDATE_CAMPAIGN_CANCELLED = makeConstant('UPDATE_CAMPAIGN_CANCELLED')
export const UPDATE_CAMPAIGN_FAILED = makeConstant('UPDATE_CAMPAIGN_FAILED')

export const RECEIVE_CAMPAIGN = makeConstant('RECEIVE_CAMPAIGN')

export const SEARCH_CAMPAIGNS = makeConstant('SEARCH_CAMPAIGNS')
export const SEARCH_CAMPAIGNS_PENDING = makeConstant('SEARCH_CAMPAIGNS_PENDING')
export const SEARCH_CAMPAIGNS_CANCELLED = makeConstant('SEARCH_CAMPAIGNS_CANCELLED')
export const SEARCH_CAMPAIGNS_FAILED = makeConstant('SEARCH_CAMPAIGNS_FAILED')
export const SEARCH_CAMPAIGNS_SUCCESS = makeConstant('SEARCH_CAMPAIGNS_SUCCESS')

export const LOAD_MORE_CAMPAIGNS = makeConstant('LOAD_MORE_CAMPAIGNS')
export const LOAD_MORE_CAMPAIGNS_PENDING = makeConstant('LOAD_MORE_CAMPAIGNS_PENDING')
export const LOAD_MORE_CAMPAIGNS_CANCELLED = makeConstant('LOAD_MORE_CAMPAIGNS_CANCELLED')
export const LOAD_MORE_CAMPAIGNS_FAILED = makeConstant('LOAD_MORE_CAMPAIGNS_FAILED')
export const LOAD_MORE_CAMPAIGNS_SUCCESS = makeConstant('LOAD_MORE_CAMPAIGNS_SUCCESS')

export const SET_DRAFT = makeConstant('SET_DRAFT')
export const RESET_DRAFT = makeConstant('RESET_DRAFT')

export const CampaignTypes = Object.freeze({
  ANNOUNCEMENT_ONE_TIME: 'ANNOUNCEMENT_ONE_TIME',
  NPS_ONE_TIME: 'NPS_ONE_TIME',
  NPS_RECURRING: 'NPS_RECURRING',
  EMAIL_CAPTURE: 'EMAIL_CAPTURE',
  BOT: 'BOT',
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/constants.js